import { render, staticRenderFns } from "./AccountSidebarTree.vue?vue&type=template&id=28ad7591"
import script from "./AccountSidebarTree.vue?vue&type=script&lang=js"
export * from "./AccountSidebarTree.vue?vue&type=script&lang=js"
import style0 from "./AccountSidebarTree.vue?vue&type=style&index=0&id=28ad7591&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports